var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTrendUp = function SvgIconTrendUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.674 4.867a1 1 0 0 0-.924-.617h-6a1 1 0 1 0 0 2h3.586l-6.586 6.586-3.043-3.043a1 1 0 0 0-1.414 0l-6.75 6.75a1 1 0 1 0 1.414 1.414L9 11.914l3.043 3.043a1 1 0 0 0 1.414 0l7.293-7.293v3.586a1 1 0 1 0 2 0V5.241a1 1 0 0 0-.076-.374"
  })));
};
export default SvgIconTrendUp;